import { useState } from 'react';
import { segment } from '@actions/analytics';
import { REFERRAL_PROMOTION_PRIZE_SELECTED } from './segment';
import PollHero from './PollHero';
import {
  HintCard,
  HintText,
  MeterFill,
  MeterRow,
  MeterTrack,
  MeterValue,
  OptionBlock,
  OptionCopy,
  OptionSub,
  OptionTitle,
  PollCard,
  PollGrid,
  PollHeader,
  PollIntro,
  PollTitleBlock,
  Radio
} from './pollScreenStyles';
import {
  Content,
  Eyebrow,
  PageShell,
  Panel,
  PollEyebrowIcon,
  PrizeArt,
  QuotesSection,
  SectionTitle
} from './shared';
import type { CampaignState, PollOption } from './types';

type PollScreenProps = {
  data: CampaignState['poll'];
};

const PollScreen = ({ data }: PollScreenProps) => {
  const [selectedId, setSelectedId] = useState(data.selectedOptionId);

  const handleOptionSelect = (option: PollOption) => {
    setSelectedId(option.id);
    segment.track(REFERRAL_PROMOTION_PRIZE_SELECTED, {
      option_selected: option.title
    });
  };

  return (
    <PageShell>
      <PollHero />
      <Content $afterHero="poll">
        <Panel>
          <PollHeader>
            <PollIntro>
              <Eyebrow>
                <PollEyebrowIcon />
                Quick poll
              </Eyebrow>
              <PollTitleBlock>
                <SectionTitle>
                  If you could pick one, what would it be? 👀
                </SectionTitle>
                <HintText>
                  Tell us what you want the most and see what other want. you
                  can select only one prize
                </HintText>
              </PollTitleBlock>
            </PollIntro>
            <HintCard>
              Tell us what you want the most and see what other want.
            </HintCard>
          </PollHeader>
          <PollGrid>
            {data.options.map((option: PollOption) => (
              <PollCard
                key={option.id}
                type="button"
                $selected={selectedId === option.id}
                onClick={() => handleOptionSelect(option)}
              >
                <Radio $selected={selectedId === option.id} />
                <PrizeArt
                  src={option.imageUrl}
                  prizeKey={option.prizeKey}
                  compact
                />
                <OptionBlock>
                  <OptionCopy>
                    <OptionTitle>{option.title}</OptionTitle>
                    <OptionSub>{option.subtitle}</OptionSub>
                  </OptionCopy>
                  <MeterRow>
                    <MeterTrack>
                      <MeterFill $value={option.percent} />
                    </MeterTrack>
                    <MeterValue>{option.percent}%</MeterValue>
                  </MeterRow>
                </OptionBlock>
              </PollCard>
            ))}
          </PollGrid>
        </Panel>
        <QuotesSection quotes={data.quotes} />
      </Content>
    </PageShell>
  );
};

export default PollScreen;
